'use client'

import { ListingCard } from '@/components/marketing/content/listing-card'
import { track } from '@/lib/analytics/track'

interface RelatedSkill {
  slug: string
  title: string
  description: string
  category: string
  iconEmoji?: string
  iconBgColor?: string
  compatibleModels: string[]
  tier?: string
}

export function RelatedSkillsGrid({
  currentSlug,
  relatedSkills,
}: {
  currentSlug: string
  relatedSkills: RelatedSkill[]
}) {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {relatedSkills.map((related, index) => (
        <ListingCard
          key={related.slug}
          href={`/skills/${related.slug}`}
          title={related.title}
          description={related.description}
          category={related.category}
          iconEmoji={related.iconEmoji}
          iconBgColor={related.iconBgColor}
          onClick={() =>
            track('skill_related_click', {
              slug: currentSlug,
              clicked_slug: related.slug,
              position: index + 1,
            })
          }
          meta={[
            related.compatibleModels.join(' · '),
            related.tier === 'certified' ? '✓ Certified' : undefined,
          ]
            .filter(Boolean)
            .join(' — ')}
        />
      ))}
    </div>
  )
}
